import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface ConcreteFIconProps {
  size?: number;
  color?: string;
}

const ConcreteFIcon: React.FC<ConcreteFIconProps> = (props) => (
  <SvgIcon {...props} className="sx-icon-concretef">
    {
      <path d="M16.938 5.422h-9.575l0.055 10.565h-4.25v2.592h17.663v-2.757l-3.949 0.031 0.056-10.432z"></path>

    }  </SvgIcon>
);

export default ConcreteFIcon;
